import * as React from "react";
import styled from "styled-components";

import { Text } from "src/library/components/Text";
import { useS3Api } from "src/core/shared/components/S3/s3.api";

interface PDFInvoiceTabProps {
  /** S3 key for the PDF invoice */
  pdfKey?: string;
  /** Loading state */
  loading?: boolean;
}

/**
 * PDF Invoice Tab - displays PDF preview with download button
 */
const PDFInvoiceTab: React.FC<PDFInvoiceTabProps> = ({
  pdfKey,
  loading = false
}) => {
  const [ fileRes, getFile ] = useS3Api("GET_PRESIGNED_URL");

  React.useEffect(() => {
    if (pdfKey) {
      getFile({ key: pdfKey });
    }
  }, [ pdfKey, getFile ]);

  if (loading || fileRes.pending) {
    return (
      <EmptyState>
        <Text color="secondary">
          Loading invoice...
        </Text>
      </EmptyState>
    );
  }

  if (!pdfKey) {
    return (
      <EmptyState>
        <Text color="secondary">
          No PDF invoice available.
        </Text>
      </EmptyState>
    );
  }

  if (fileRes.error) {
    return (
      <EmptyState>
        <Text color="secondary">
          Failed to load PDF invoice.
        </Text>
      </EmptyState>
    );
  }

  return (
    <PDFContainer>

      <PDFPreview>
        <object
          data={fileRes.data?.signedUrl}
          type="application/pdf"
          width="100%"
          title="Invoice PDF"
          height="max-content"
          style={{ border: "none" }}
        >
          <p>
            Can't display PDF.
            <a href={fileRes.data?.signedUrl}>
              Download it here
            </a>
          </p>
        </object>

      </PDFPreview>
    </PDFContainer>
  );
};

export default PDFInvoiceTab;

const PDFContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.margins.md};
`;

const PDFPreview = styled.div`
  width: 100%;
  min-height:80vh;
  border: 1px solid ${({ theme }) => theme.colors.lightGrey};
  border-radius: 4px;
  overflow: hidden;
  display: flex;
`;

const EmptyState = styled.div`
  padding: ${({ theme }) => theme.spacing.padding.xl};
  text-align: center;
`;
